import camelCase from 'lodash/camelCase';
import isEmpty from 'lodash/isEmpty';

import { PREMIUM_SERVICE_DEFAULT_ENABLED } from 'constants/premium-services';

export const isBlockAvailableForSite = (block, siteData) => {
  const { requiredPremiumServices } = block;
  if (isEmpty(requiredPremiumServices)) return true;

  return requiredPremiumServices.every((service) => {
    const value = siteData[camelCase(`enabled_${service}`)];
    if (value === undefined || value === null) {
      return PREMIUM_SERVICE_DEFAULT_ENABLED[service];
    }
    return value;
  });
};

export const filterBlocksByPremiumServices = (blocks, siteData) =>
  blocks.filter((block) => isBlockAvailableForSite(block, siteData));
